up.compiler('[scrollable-pagination]', (element) => {
  const focusedButton = element.querySelector('[scrollable-pagination--focused = true]')
  const xOffset = focusedButton.getBoundingClientRect().left
  const paginationWidth = element.offsetWidth

  element.scroll(xOffset - (paginationWidth / 2), 0)
})
